export const FEATURE_SELECTION = [
  "Asesmen",
  "Dashboard",
  "Staf",
  "Tanda Terima",
  "Slip Gaji",
  "Absen",
  "Cuti",
  "Dokumen",
  "Kalender",
  "Shift",
  // "Panduan",
  "Pengaturan",
  "Pengaturan Unit Kerja",
  "Pengaturan Tipe Absensi",
  // "Pengaturan Tipe Staf",
  "Pengaturan Status Staf",
  "Pengaturan Group Staf",
  "Pengaturan Slip Gaji",
  "Pengaturan Kurir",
  // "Pengaturan User Role"
  "Pengaturan Admin"
];

// Create, Read, Update, Delete
// Update Status : Update function for feature's status
// Operasi : show columns "Operasi" of feature
/* Other :
 * Transaksi : Cetak Laporan
 */
export const FEATURE_FUNCTION_SELECTION = {
  Staff: {
    Create: true,
    Absen: true,
    Cuti: true,
    Update: true,
    Delete: true,
  },
  TandaTerima: {
    Create: true,
    Update: true,
    Delete: true,
  },
  Absen: {
    Absen: true,
    Update: true,
    Delete: true
  },
  Cuti: {
    Create: true,
  },
  Dokumen: {
    Create: true,
    Delete: true
  }, 
  Kalender: {
    Create: true
  },
  Shift: {
    Create: true
  },
  SendEmail: {
    Send: false,
  },
  Asesmen: {
    Update: true,
  },
  AsesmenKelompok: {
    Update: true,
  },
};


export const PERMISSIONS = {
  // DASHBOARD
  VIEW_DASHBOARD: 'view_dashboard',
  
  // STAF
  VIEW_STAF: 'view_staf',
  ADD_STAF: 'add_staf',
  CHANGE_STAF: 'change_staf',
  DELETE_STAF: 'delete_staf',

  // TANDA TERIMA
  VIEW_TANDA_TERIMA: 'view_tanda_terima',
  ADD_TANDA_TERIMA: 'add_tanda_terima',
  CHANGE_TANDA_TERIMA: 'change_tanda_terima',
  DELETE_TANDA_TERIMA: 'delete_tanda_terima',
  
  // KURIR
  VIEW_KURIR_LIST: 'view_kurir_list',
  ADD_TANDA_TANGAN_PEMBERI_TUGAS: 'add_tanda_tangan_pemberi_tugas',
  ADD_TANDA_TANGAN_YANG_MENYERAHKAN: 'add_tanda_tangan_yang_menyerahkan',
  ADD_TANDA_TANGAN_PENERIMA: 'add_tanda_tangan_penerima',
  
  // SLIP GAJI
  ADD_SLIP_GAJI: 'add_slip_gaji',

  // ABSENSI
  VIEW_ABSENSI: 'view_absensi',
  ADD_ABSENSI: 'add_absensi',
  CHANGE_ABSENSI: 'change_absensi',
  DELETE_ABSENSI: 'delete_absensi',

  // USER (DILAYOUT GAK DIPAKE)
  USER_CREATE: 'add_user',
  USER_EDIT: 'change_user',
  USER_DELETE: 'delete_user',

  // CUTI
  VIEW_CUTI: 'view_cuti',
  ADD_CUTI: 'add_cuti',
  CHANGE_CUTI: 'change_cuti',
  DELETE_CUTI: 'delete_cuti',
  VIEW_REKAP_CUTI: 'view_rekap_cuti',
  VIEW_DALAM_PROSES_CUTI: 'view_dalam_proses_cuti',
  
  // DOKUMEN
  VIEW_DOKUMEN: 'view_dokumen',
  ADD_DOKUMEN: 'add_dokumen',
  CHANGE_DOKUMEN: 'change_dokumen',
  DELETE_DOKUMEN: 'delete_dokumen',

  // KALENDER
  VIEW_KALENDER: 'view_kalender',
  ADD_KALENDER: 'add_kalender',

  // SHIFT
  VIEW_SHIFT: 'view_shift',
  ADD_SHIFT: 'add_shift',
  DELETE_SHIFT: 'delete_shift',
  CHANGE_SHIFT: 'change_shift',
  
  // PENGATURAN
  VIEW_PENGATURAN_UNIT_KERJA: 'view_pengaturan_unit_kerja',
  ADD_PENGATURAN_UNIT_KERJA: 'add_pengaturan_unit_kerja',
  CHANGE_PENGATURAN_UNIT_KERJA: 'change_pengaturan_unit_kerja',
  DISPLAY_PENGATURAN_UNIT_KERJA: 'display_pengaturan_unit_kerja',
  
  VIEW_PENGATURAN_TIPE_ABSENSI: 'view_pengaturan_tipe_absensi',
  ADD_PENGATURAN_TIPE_ABSENSI: 'add_pengaturan_tipe_absensi',
  CHANGE_PENGATURAN_TIPE_ABSENSI: 'change_pengaturan_tipe_absensi',
  DISPLAY_PENGATURAN_TIPE_ABSENSI: 'display_pengaturan_tipe_absensi',

  VIEW_PENGATURAN_STATUS_STAF: 'view_pengaturan_status_staf',
  ADD_PENGATURAN_STATUS_STAF: 'add_pengaturan_status_staf',
  CHANGE_PENGATURAN_STATUS_STAF: 'change_pengaturan_status_staf',
  DISPLAY_PENGATURAN_STATUS_STAF: 'display_pengaturan_status_staf',

  VIEW_PENGATURAN_GROUP_STAF: 'view_pengaturan_group_staf',
  ADD_PENGATURAN_GROUP_STAF: 'add_pengaturan_group_staf',
  CHANGE_PENGATURAN_GROUP_STAF: 'change_pengaturan_group_staf',
  DISPLAY_PENGATURAN_GROUP_STAF: 'display_pengaturan_group_staf',
  
  VIEW_PENGATURAN_SLIP_GAJI: 'view_pengaturan_footer',
  ADD_PENGATURAN_SLIP_GAJI: 'add_pengaturan_footer',
  CHANGE_PENGATURAN_SLIP_GAJI: 'change_pengaturan_footer',
  DISPLAY_PENGATURAN_SLIP_GAJI: 'display_pengaturan_footer',

  VIEW_PENGATURAN_ADMIN: 'view_pengaturan_admin',
  ADD_PENGATURAN_ADMIN: 'add_pengaturan_admin',
  CHANGE_PENGATURAN_ADMIN: 'change_pengaturan_admin',

  VIEW_PENGATURAN_KURIR: 'view_pengaturan_kurir',
  ADD_PENGATURAN_KURIR: 'add_pengaturan_kurir',
  CHANGE_PENGATURAN_KURIR: 'change_pengaturan_kurir',

  // ADD_PENGATURAN_TIPE_STAF: 'add_pengaturan_tipe_staf',
  // VIEW_PENGATURAN_TIPE_STAF: 'view_pengaturan_tipe_staf',
  // CHANGE_PENGATURAN_TIPE_STAF: 'change_pengaturan_tipe_staf',
  // DISPLAY_PENGATURAN_TIPE_STAF: 'display_pengaturan_tipe_staf',

};
